module.exports = __webpack_public_path__ + "img/9788974148584.afc9172a.jpg";